import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import '../client/temp-common-imports';
import { PageData } from 'bernie-http';

import { pageNames } from '../data/page-names';
import analyticsUtil from '../util/analytics-util';
import { AnalyticsStore } from 'bernie-plugin-mobx';
import { UiStore } from '../stores';

export class UnsubscribeController implements Controller {
  public bundles = [];
  public exact = true;
  public pageId = pageNames.unsubscribe;
  public path = '/app/unsubscribe';
  public routeName = 'unsubscribe';

  public component = codeSplit(() => import(/* webpackChunkName: "signin-page" */ '../views/unsubscribe-page'));

  public fetch(options: FetchOptions): Promise<Result> {
    const { stores, request } = options;
    const analyticsStore: AnalyticsStore = stores && stores.get<AnalyticsStore>('analytics');
    const context = request.context;

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, context);

    return Promise.resolve(undefined);
  }

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Unsubscribe' }) as Promise<PageData>;
  }
}
